module.exports = __webpack_public_path__ + "fonts/bootstrap-icons.ed62b9f1.woff2";